import React, { useState } from "react";
import Button from "@mui/material/Button";
import { useLocation, useNavigate, Link } from "react-router-dom";
import useUser from "context/user/useUser";
import { getUser, getUserLevel, signIn } from "auth/authenticate";
import { Alert, Link as MUILink } from "@mui/material";
import res from "../../../resources";
import theme from "theme/Theme";
export default function LoginForm(props) {
  const { redirectlinks = true, title = "Welcome Back" } = props;
  const navigate = useNavigate();
  const location = useLocation();
  const { setUserRole, setUser } = useUser();
  const [email, setEmail] = React.useState("");
  const [password, setPassword] = React.useState("");
  const [values, setValues] = React.useState({
    password: "",
    showPassword: false,
  });
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");

  const handleClickShowPassword = () => {
    setValues({ ...values, showPassword: !values.showPassword });
  };

  const handlePasswordChange = (prop) => (event) => {
    setValues({ ...values, [prop]: event.target.value });
  };

  const validateEmail = (email) => {
    return String(email)
      .toLowerCase()
      .match(
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      );
  };

  const validate = () => {
    if (!email) {
      setError("Email Address is Required!");
      return false;
    } else if (!validateEmail(email)) {
      setError("Email Address is Not Valid!");
      return false;
    } else if (!values.password) {
      setError("Password is Required!");
      return false;
    }
    setError(undefined);
    return true;
  };

  async function systemSignIn() {
    if (validate()) {
      const signinData = await signIn(email, values.password);

      if (signinData.success) {
        setUser(getUser()); // getUser() parses the token and returns user info including userId
    setUserRole(getUserLevel());
    // setUser(signinData.user);
    //     setUserRole(signinData.user?.userType);
        redirectlinks && navigate("/patient-dashboard");
      } else {
        if (signinData?.message) {
          setError(signinData.message);
        }
      }
    }
  }

  return (
    <div className="log_right2">
      <div className="log_card2 ">
        <h3 className="welcome_text2">{title}</h3>

        <div className="input_field_login2">
          <div className=" password_wrapper2">
            <input
              type="text"
              autoComplete="off"
              onChange={(e) => setEmail(e.target.value)}
              value={email}
              className="log_input_password2"
              placeholder="Email"
              onKeyPress={(event) => {
                if (event.key === "Enter") systemSignIn();
              }}
            ></input>
            <Button style={{ padding: "0", height: "100%" }}>
              {validateEmail(email) && (
                <img
                  src={res.Images.icons.check.default}
                  style={{ width: "15px", color: "#677294;" }}
                  alt=""
                />
              )}
            </Button>
          </div>
        </div>
        <div className="input_field_login2">
          <div className=" password_wrapper2">
            <input
              type={values.showPassword ? "text" : "password"}
              onChange={handlePasswordChange("password")}
              value={values.password}
              className="log_input_password2"
              placeholder="Password"
              autoComplete="off"
              onKeyPress={(event) => {
                if (event.key === "Enter") systemSignIn();
              }}
            ></input>
            <Button
              onClick={() => handleClickShowPassword()}
              style={{ padding: "0", height: "100%" }}
            >
              {values.showPassword ? (
                <img
                  src={res.Images.icons.eyeOff.default}
                  style={{ width: "15px", color: "#677294;" }}
                  alt=""
                />
              ) : (
                <img
                  src={res.Images.icons.eye.default}
                  style={{ width: "15px", color: "#677294;" }}
                  alt=""
                />
              )}
            </Button>
          </div>
        </div>
        {error && (
          <Alert severity="error" style={{ margin: "8px" }}>
            {error}
          </Alert>
        )}

        {success && <Alert style={{ margin: "8px" }}>{success}</Alert>}

        <div className="button_field margin-top">
          <Button
            variant="contained"
            style={{ marginTop: "0px" }}
            className="payBtn log_submit_btn"
            onClick={(e) => {
              systemSignIn();
            }}
          >
            Sign In
          </Button>
        </div>
        {redirectlinks && (
          <>
            <div className="text_fogot-password">
              <Link to={"/forgetpassword"} style={{ textDecoration: "none" }}>
                <p
                  style={{
                    fontSize: "12px",
                    color: "#265ED7",
                    fontWeight: "600",
                  }}
                >
                  Forgot password
                </p>
              </Link>
            </div>
            <div className="text_fogot-join-us">
              <Link
                to={"/registration"}
                className="mt-0 pt-0"
                style={{ textDecoration: "none" }}
              >
                <p
                  style={{
                    fontSize: "12px",
                    color: "#265ED7",
                    fontWeight: "600",
                  }}
                  className="mt-0"
                >
                  Don't have an account? Join us
                </p>
              </Link>
            </div>
            <hr style={{border: 'none', height: '0.5px', backgroundColor: '#333',width: '80%', margin: '20px auto', }}/>
            <div className="text_fogot-join-us">
              <MUILink
                component="button"
                className="mt-0 pt-0"
                sx={{
                  marginX:'auto',
                  textDecoration: "none",
                  display: "block",
                  mt: 2,
                  cursor: "pointer",
                  transition: "color 0.2s ease",
                  "&:hover": {
                    color: theme.palette.primary.main,
                  },
                }}
                onClick={() => {
                  const doctorUrl =
                    process.env.REACT_APP_DOCTOR_PORTAL_URL + "login";
                  // console.log("Doctor URL:", doctorUrl);
                  if (doctorUrl) {
                    window.open(doctorUrl, "_blank", "noopener,noreferrer");
                  } else {
                    // console.error("Doctor URL is not set");
                  }
                }}
              >
                A Doctor or any Health Professional? Login as a HSP (Health Service Provider)
              </MUILink>
            </div>
          </>
        )}
      </div>
    </div>
  );
}
